import { ShoppingListAddToCartModel, ShoppingListCreateModel, ShoppingListModel } from "@/types/api"
import { baseApi } from "./baseApi"

const shoppingListApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getShoppingList: builder.query<ShoppingListModel, string>({
      query: (listId: string) => `ShoppingList/${listId}`,
    }),
    addShoppingList: builder.mutation<string, ShoppingListCreateModel>({
      query: (payload) => ({
        url: `ShoppingList`,
        method: "POST",
        body: payload,
      })
    }),
    addShoppingListToCart: builder.mutation<void, ShoppingListAddToCartModel>({
      query: (payload) => ({
        url: `ShoppingListCart`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Cart"],
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetShoppingListQuery,
  useAddShoppingListMutation,
  useAddShoppingListToCartMutation,
} = shoppingListApi